import { CSSProperties, memo } from "react";
import { clsx } from "clsx";


import cls from "./Skeleton.module.scss";

interface SkeletonProps {
  className?: string;
  height?: string | number;
  width?: string | number;
  borderRadius?: string | number;
}

export const Skeleton = memo((props: SkeletonProps) => {
  const { className, height, width, borderRadius } = props;

  const styles: CSSProperties = {
    width,
    height,
    borderRadius,
  };

  return <div className={clsx(cls.Skeleton, {}, [className])} style={styles} />;
});
